export const COMPANY_DOCUMENTS = [
  {
    key: 'acta_constitutiva',
    label: 'Acta Constitutiva',
    category: 'Legal',
    description: 'Documento que acredita la creación formal de la empresa.',
    required: true,
  },
  {
    key: 'rfc',
    label: 'RFC',
    category: 'Fiscal',
    description: 'Constancia del Registro Federal de Contribuyentes.',
    required: true,
  },
  {
    key: 'comprobante_domicilio',
    label: 'Comprobante de Domicilio',
    category: 'Legal',
    description: 'Recibo de servicios o documento bancario con dirección vigente.',
    required: true,
  },
  {
    key: 'licencia_funcionamiento',
    label: 'Licencia de Funcionamiento',
    category: 'Operativo',
    description: 'Permiso otorgado por la autoridad para operar.',
    required: true,
  },
  {
    key: 'iso_9001',
    label: 'Certificado ISO 9001',
    category: 'Certificaciones',
    description: 'Certificación de gestión de calidad (si aplica).',
    required: false,
  },
  {
    key: 'seguro_responsabilidad_civil',
    label: 'Seguro de Responsabilidad Civil',
    category: 'Seguros',
    description: 'Cobertura vigente de responsabilidad civil.',
    required: true,
  },
  {
    key: 'curp_representante_legal',
    label: 'CURP del Representante Legal',
    category: 'Legal',
    description: 'Clave Única del representante legal.',
    required: true,
  },
  {
    key: 'identificacion_oficial',
    label: 'Identificación Oficial (INE/IFE)',
    category: 'Legal',
    description: 'Identificación vigente del representante.',
    required: true,
  },
  {
    key: 'poliza_autos',
    label: 'Póliza de Autos',
    category: 'Seguros',
    description: 'Cobertura para la flota vehicular.',
    required: false,
  },
  {
    key: 'carta_poder',
    label: 'Carta Poder',
    category: 'Legal',
    description: 'Carta poder simple o notariada que autoriza gestiones.',
    required: false,
  },
  {
    key: 'estado_cuenta_bancario',
    label: 'Estado de Cuenta Bancario',
    category: 'Financiero',
    description: 'Estado de cuenta reciente para validar solvencia.',
    required: true,
  },
];

export const COMPANY_DOCUMENT_MAP = COMPANY_DOCUMENTS.reduce((acc, doc) => {
  acc[doc.key] = doc;
  return acc;
}, {});
